module.exports = __webpack_public_path__ + "img/product-icon4.39771492.png";